export const apiTags = {
  user: "USER",
  profile: "PROFILE",
  updateProfile: "UPDATE_PROFILE",
}
